export { Typography } from './Typography'
export { getTypographyIntent, typographyWeights } from './Typography.styles'
export type {
  Intent as TypographyIntent,
  TypographyProps,
  Weight as TypographyWeight,
} from './Typography.types'
